import { render, staticRenderFns } from "./RemoveFromCartConfirm.vue?vue&type=template&id=ba2f4e9e"
import script from "./RemoveFromCartConfirm.vue?vue&type=script&lang=js"
export * from "./RemoveFromCartConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports